const { REACT_APP_BUILD_ENV } = process.env;

// in DEV (localhost) environment, use DEV_APP_ENV
// as configured in public/dev.config.js
let externalHost = window.DEV_APP_ENV && window.DEV_APP_ENV.hosts && window.DEV_APP_ENV.hosts.formsService;

// override DEV externalHost with deployed (environment) externalHost
// APP_ENV is only available in deployed (RF/configgy) builds,
// as configured in public/config.js (auto-generated) file via RF build
if (window.APP_ENV && window.APP_ENV.hosts && window.APP_ENV.hosts.formsService) {
    externalHost = window.APP_ENV.hosts.formsService;
}

const hostLocations = {
    dev: externalHost,
    manager: externalHost,
    submit: externalHost
};

export const API_PATH = hostLocations[REACT_APP_BUILD_ENV];
